import { render } from "./DropdownMenuHeading.vue?vue&type=template&id=eb7ec92a"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DropdownMenuHeading.vue"]])

export default __exports__